import { Trigger } from '@radix-ui/react-popover';

export const PopoverTrigger = Trigger;
